import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "bone";

function GIBone() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIBone;